import { render, staticRenderFns } from "./touZiXiangMu.vue?vue&type=template&id=f1a9351e&"
import script from "./touZiXiangMu.vue?vue&type=script&lang=js&"
export * from "./touZiXiangMu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports